import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { BanksQueryParams } from '../shared/interfaces/banks-query-params';
import { BankResponse, Summary } from '../shared/interfaces/bank-response.interface';
import { DistinctValuesResponse } from '../shared/interfaces/distinct-values-response.interface';
import { FxrateQueryParamsInterface } from '../shared/interfaces/fxrate-interface';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  // readonly baseUrl = environment.url;
  readonly intermediaryBaseUrl = environment.intermediaryUrl;
  constructor(public http: HttpClient) {}

  postData(serviceName: string, data: any) {
    return this.http.post(this.buildUrl(serviceName), data, { headers: this.getHeaders() });
  }

  getData(serviceName: string) {
    return this.http.get(this.buildUrl(serviceName), { headers: this.getHeaders() });
  }

  deleteData(serviceName: string, id: any) {
    const options = { headers: this.getHeaders() };
    return this.http.delete(`${this.buildUrl(serviceName)}/${id}`, options);
  }

  getCurrencyWithBank() {
    const baseUrl = environment.intermediaryUrl + 'cash-transactions/currencies-banks-accounts';
    return this.http.get(baseUrl, { headers: this.getHeaders() });
  }
  getBankList() {
    const baseUrl = environment.intermediaryUrl + 'banks';
    return this.http.get(baseUrl, { headers: this.getHeaders() });
  }

  getBankSummary(params: Partial<BanksQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${environment.intermediaryUrl}banks/summary`, {
      params: this.queryCleaner(params),
    });
  }

  getBankData(params: Partial<BanksQueryParams>): Observable<BankResponse> {
    const baseUrl = environment.intermediaryUrl + 'banks';
    return this.http.get<BankResponse>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getFilterDistinctValues(): Observable<DistinctValuesResponse> {
    return this.http.get<DistinctValuesResponse>(`${environment.intermediaryUrl}banks/filter-distinct-values`);
  }

  getFxRateData(params: Partial<FxrateQueryParamsInterface>): Observable<any> {
    return this.http.get<any>(`${this.intermediaryBaseUrl}fx-rates?`, {
      params: this.queryCleaner(params),
    });
  }

  deleteBankAccount(id: any) {
    const baseUrl = environment.intermediaryUrl + 'banks/accounts/' + id;
    return this.http.delete(baseUrl);
  }

  bulkDeleteBankData(ids: number[]) {
    const baseUrl = `${environment.intermediaryUrl}banks/bulk-delete`;
    return this.http.delete(baseUrl, { body: { ids } });
  }

  upload(file: any, type: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    let uploadType = 'upload';
    let baseUrl = environment.intermediaryUrl + 'csv/' + uploadType;

    if (type == 'investment') {
      uploadType = 'upload';
      baseUrl = environment.intermediaryUrl + 'investments/import';
    } else if (type == 'bank') {
      baseUrl = environment.intermediaryUrl + 'banks/import';
      uploadType = 'banksUpload';
    } else if (type == 'ETR') {
      uploadType = 'etrUpload';
      baseUrl = environment.intermediaryUrl + 'etr/import';
    }
    return this.http.post(baseUrl, formData);
  }

  uploadValidate(file: any, type: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const uploadType = 'upload';
    let baseUrl = environment.intermediaryUrl + 'csv/' + uploadType;
    if (type == 'investment') {
      baseUrl = environment.intermediaryUrl + 'investments/validate-import';
    } else if (type == 'bank') {
      baseUrl = environment.intermediaryUrl + 'banks/validate-import';
    } else if (type == 'ETR') {
      baseUrl = environment.intermediaryUrl + 'etr/validate-import';
    }
    return this.http.post(baseUrl, formData);
  }

  queryCleaner<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] && params[paramsKey as keyof T] !== 0) {
        delete (params as any)[paramsKey];
      }
    }
    return params;
  }

  queryCleanerBulk<T>(params: Partial<T>): { [key: string]: any } {
    for (const paramsKey in params) {
      if (!params[paramsKey as keyof T] || params[paramsKey as keyof T] === '~') {
        (params as any)[paramsKey] = null;
      }
    }
    return params;
  }

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    });
  }

  buildUrl(serviceName: string): string {
    return `${this.intermediaryBaseUrl}${serviceName}`;
  }
}
